<template>
  <div>
    <slot></slot>
  </div>
</template>
<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
  props: ['value', 'axis', 'appendTo'],
});
</script>
